'use client';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import React from 'react';
import {
   Box, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay,
   Flex, Input, InputGroup, Spinner, Table, Tbody, Td, Text, Tr,
   useColorMode, useColorModeValue, useDisclosure, useOutsideClick,
} from '@chakra-ui/react';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Thead, Th, Grid } from '@chakra-ui/react';
import Select from 'react-select';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import DynamicFilterall from '../components/DynamicFilterall';
import SalesPurchaseFilter from '../components/SalesPurchaseFilter';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { getInventoryDetailReport } from '../../../../redux/actions/reports';
import { createColumnHelper } from '@tanstack/react-table';
import { useGlobal } from '../../../../contexts';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { getShareCompanyOptions } from 'utils/util';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { useUser } from 'contexts';
import { LuRefreshCcw } from 'react-icons/lu';
import { IoFilterOutline } from 'react-icons/io5';
import { motion } from 'framer-motion';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { MdCompress, MdExpand } from 'react-icons/md';
import * as XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getSinglePurchaseWithPrevAndNext } from '../../../../redux/actions/purchaseInvoice';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById } from '../../../../redux/actions/account';
import { deletePurchaseReturnInvoice, getSinglePurchaseReturn, getSinglePurchaseReturnWithPrevAndNext } from '../../../../redux/actions/purchaseReturnInvoice';
import { deleteSaleReturnInvoice, getSingleSalesReturnWithPrevAndNext } from '../../../../redux/actions/salesReturnInvoice';
import { deleteRecord, deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
import { VariableSizeList } from 'react-window';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);
const COL_PX = {
   date: 110,
   docno: 100,
   account: null,
   daybook: 180,
   recqty: 115,
   issqty: 115,
   balqty: 115,
   rate: 115,
};

const TableColGroup = () => (
   <colgroup>
      <col style={{ width: COL_PX.date + 'px', minWidth: COL_PX.date + 'px' }} />
      <col style={{ width: COL_PX.docno + 'px', minWidth: COL_PX.docno + 'px' }} />
      <col /* account — auto */ />
      <col style={{ width: COL_PX.daybook + 'px', minWidth: COL_PX.daybook + 'px' }} />
      <col style={{ width: COL_PX.recqty + 'px', minWidth: COL_PX.recqty + 'px' }} />
      <col style={{ width: COL_PX.issqty + 'px', minWidth: COL_PX.issqty + 'px' }} />
      <col style={{ width: COL_PX.balqty + 'px', minWidth: COL_PX.balqty + 'px' }} />
      <col style={{ width: COL_PX.rate + 'px', minWidth: COL_PX.rate + 'px' }} />
   </colgroup>
);

const VirtualizedTransactionRows = React.memo(({
   transactions, columnsReportsSalesDetail, isDark,
   formatCurrencyWithSmallDecimal, formatDateToDDMMYYYY, handledata, companyData,
}) => {
   const openingBal = companyData[0]?.totalOpeningBal1;
   const hasOpeningBal = openingBal > 0;

   const items = useMemo(() => {
      const rows = [];
      if (hasOpeningBal) rows.push({ __type: 'openingBalance', value: openingBal });
      transactions.forEach((t) => rows.push({ __type: 'transaction', data: t }));
      return rows;
   }, [transactions, hasOpeningBal, openingBal]);

   const getItemSize = useCallback((i) => (items[i].__type === 'openingBalance' ? 42 : 40), [items]);

   const totalHeight = useMemo(
      () => items.reduce((sum, _, i) => sum + getItemSize(i), 0),
      [items, getItemSize],
   );

   const Row = useCallback(({ index, style }) => {
      const item = items[index];

      if (item.__type === 'openingBalance') {
         return (
            <div style={style}>
               <Flex
                  bg={isDark ? '#2D3748' : '#FFFBEB'}
                  borderLeft="3px solid"
                  borderColor={isDark ? '#D97706' : '#92400E'}
                  align="center" h="100%" gap={0}
               >
                  <Box flexShrink={0} style={{ width: COL_PX.date + 'px' }} />
                  <Box flexShrink={0} style={{ width: COL_PX.docno + 'px' }} />
                  <Box flex="1 1 auto" px="8px"
                     fontSize="14px" fontWeight={700}
                     color={isDark ? '#FCD34D' : '#78350F'}>
                     Opening Balance
                  </Box>
                  <Box flexShrink={0} style={{ width: COL_PX.daybook + 'px' }} />
                  <Box flexShrink={0} style={{ width: COL_PX.recqty + 'px' }} />
                  <Box flexShrink={0} style={{ width: COL_PX.issqty + 'px' }} />
                  <Box flexShrink={0} style={{ width: COL_PX.balqty + 'px' }}
                     textAlign="right" pr="12px"
                     fontSize="14px" fontWeight={700}
                     color={isDark ? '#FCD34D' : '#78350F'}>
                     {formatCurrencyWithSmallDecimal(item.value)}
                  </Box>
                  <Box flexShrink={0} style={{ width: COL_PX.rate + 'px' }} />
               </Flex>
            </div>
         );
      }

      const t = item.data;
      return (
         <div style={style}>
            <Flex
               bg={isDark ? '#1A202C' : '#FFFFFF'}
               onClick={() => handledata(t)}
               cursor="pointer"
               align="center" h="100%" gap={0}
               borderBottom="1px solid"
               borderBottomColor={isDark ? '#2D3748' : '#E2E8F0'}
               transition="background 0.15s"
               _hover={{ bg: isDark ? '#2D3748' : '#EBF8FF' }}
            >
               {/* DATE */}
               <Box flexShrink={0} style={{ width: COL_PX.date + 'px' }}
                  px="8px" fontSize="13px" fontWeight={500}
                  color={isDark ? '#CBD5E0' : '#4A5568'}
                  overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
                  {t.transactionAt ? formatDateToDDMMYYYY(t.transactionAt) : ''}
               </Box>
               {/* DOC# */}
               <Box flexShrink={0} style={{ width: COL_PX.docno + 'px' }}
                  px="8px" fontSize="13px" fontWeight={600}
                  color={isDark ? '#90CDF4' : '#2B6CB0'}
                  overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
                  {`${t.prefix || ''}${t.docno || ''}${t.postFix || ''}` || ''}
               </Box>
               {/* ACCOUNT */}
               <Box flex="1 1 auto" px="8px" fontSize="13px" fontWeight={500}
                  color={isDark ? '#E2E8F0' : '#2D3748'}
                  overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
                  {t.accountName || ''}
               </Box>
               {/* DAYBOOK */}
               <Box flexShrink={0} style={{ width: COL_PX.daybook + 'px' }}
                  px="8px" fontSize="13px" fontWeight={500}
                  color={isDark ? '#A0AEC0' : '#718096'}
                  overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
                  {t.daybookName || ''}
               </Box>
               {/* RECEIPTS QTY */}
               <Box flexShrink={0} style={{ width: COL_PX.recqty + 'px' }}
                  pr="12px" fontSize="13px" fontWeight={600} textAlign="right"
                  color={isDark ? '#68D391' : '#276749'}>
                  {t.qty1 !== undefined && t.qty1 > 0 ? formatCurrencyWithSmallDecimal(t.qty1) : '-'}
               </Box>
               {/* ISSUES QTY */}
               <Box flexShrink={0} style={{ width: COL_PX.issqty + 'px' }}
                  pr="12px" fontSize="13px" fontWeight={600} textAlign="right"
                  color={isDark ? '#FC8181' : '#C53030'}>
                  {t.qty1 !== undefined && t.qty1 < 0 ? formatCurrencyWithSmallDecimal(Math.abs(t.qty1)) : '-'}
               </Box>
               {/* BALANCE QTY */}
               <Box flexShrink={0} style={{ width: COL_PX.balqty + 'px' }}
                  pr="12px" fontSize="13px" fontWeight={600} textAlign="right"
                  color={isDark ? '#B794F4' : '#553C9A'}>
                  {t.bal1 !== undefined ? formatCurrencyWithSmallDecimal(t.bal1) : ''}
               </Box>
               {/* RATE */}
               <Box flexShrink={0} style={{ width: COL_PX.rate + 'px' }}
                  pr="12px" fontSize="13px" fontWeight={500} textAlign="right"
                  color={isDark ? '#CBD5E0' : '#4A5568'}>
                  {t.itemRate !== undefined ? formatCurrencyWithSmallDecimal(t.itemRate, true) : ''}
               </Box>
            </Flex>
         </div>
      );
   }, [items, isDark, handledata, formatCurrencyWithSmallDecimal, formatDateToDDMMYYYY]);

   if (!items.length) return null;
   return (
      <VariableSizeList
         height={totalHeight}
         itemCount={items.length}
         itemSize={getItemSize}
         width="100%"
         overscanCount={10}
      >
         {Row}
      </VariableSizeList>
   );
});

const InventoryDetail = () => {
   const { companyList, company } = useGlobal();
   const { userGlobalSettingsData } = useGlobal();
   const columnHelper = createColumnHelper();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const storedCompanyId = localStorage.getItem('companyId');
   const [fromDate, setFromDate] = useState(null);
   const [allExpanded, setAllExpanded] = useState(false);
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const [companyFilter, setCompanyFilter] = useState([]);
   const dbName = company?.dbName;
   const [expandedItems, setExpandedItems] = useState({});
   const dispatch = useDispatch();
   const fromDateInputRef = useRef(null);
   const { user } = useUser();
   const admin = user?.isAdmin;
   const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [searchQuery, setSearchQuery] = useState('');
   const [isSearchLoading, setIsSearchLoading] = useState(false);
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);
      return { fromDate: sevenDaysAgo.toISOString().split('T')[0], toDate: today.toISOString().split('T')[0] };
   });
   const searchTimeoutRef = useRef(null);
   const abortControllerRef = useRef(null);
   const [isLoading, setIsLoading] = useState(false);
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const isFirstRenderFilter = useRef(true);

   const salesReport = useSelector((state) => state.reports?.inventoryDetail || []);

   const [entityType, setEntityType] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();

   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') return state?.receiveInventory?.single || {};
      if (entityType === 'issuemaster') return state?.issueInventory?.single || {};
      return {};
   });

   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const saleInvoiceRight = Array.isArray(userRights) ? userRights.find((r) => r.companyId === companyId)?.saleinvoice : null;
   const saleReturnRight = Array.isArray(userRights) ? userRights.find((r) => r.companyId === companyId)?.salereturn : null;
   const purchaseInvoiceRight = Array.isArray(userRights) ? userRights.find((r) => r.companyId === companyId)?.purchaseinvoice : null;
   const purchaseReturnRight = Array.isArray(userRights) ? userRights.find((r) => r.companyId === companyId)?.purchasereturn : null;

   const account = useSelector((state) => state.account.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);

   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityType === 'purchasereturn' ? viewDatapr?.data[0]
            : entityType === 'salereturn' ? viewDatasr?.data[0]
               : entityType === 'saleinvoice' ? viewDatasi
                  : entityType === 'purchaseinvoice' ? viewDatapi
                     : null;
      const pagination =
         entityType === 'purchasereturn' ? viewDatapr?.pagination
            : entityType === 'salereturn' ? viewDatasr?.pagination
               : entityType === 'saleinvoice' ? viewDatasi?.pagination
                  : entityType === 'purchaseinvoice' ? viewDatapi?.pagination
                     : null;
      return { viewDetail: data, paginate: pagination };
   }, [viewDatapr?.data, viewDatapr?.pagination, viewDatasr?.data, viewDatasr?.pagination, viewDatasi, viewDatapi]);

   const handleCompanyChange = useCallback((sel) => setCompanyFilter(sel ?? []), []);
   const toggleExpand = useCallback((id) => setExpandedItems((prev) => ({ ...prev, [id]: !prev[id] })), []);

   const companyOptions = useMemo(() => getShareCompanyOptions({ dbName, company: companyList }), [companyList, dbName]);
   const lastcompanyOptions = useMemo(() => {
      const currentUserCode = user?.loginhistory?.code;
      const currentCompanyId = user?.loginhistory?.companyId;

      // SHARED COMPANY MODE: When code is present
      if (currentUserCode) {
         // Find the company with matching ID AND matching dbName
         const sharedCompany = companyList.find(
            company => company.id === currentCompanyId && company.dbName === currentUserCode
         );

         if (sharedCompany) {
            return [{
               value: sharedCompany.id,
               label: sharedCompany.name,
               id: sharedCompany.id,
               name: sharedCompany.name,
            }];
         }

         // Fallback: try to find by dbName only
         const companiesWithDbName = companyList.filter(company => company.dbName === currentUserCode);
         if (companiesWithDbName.length > 0) {
            return companiesWithDbName.map(company => ({
               value: company.id,
               label: company.name,
               id: company.id,
               name: company.name,
            }));
         }

         return [];
      }

      // NORMAL MODE: When no code, show companies without dbName
      return companyList
         .filter(company => !company.dbName)
         .map(company => ({
            value: company.id,
            label: company.name,
            id: company.id,
            name: company.name,
         }));
   }, [companyList, user?.loginhistory?.code, user?.loginhistory?.companyId]);

   const handleNextPage = useCallback(() => { console.log('Next'); }, []);
   const handlePrevPage = useCallback(() => { console.log('Prev'); }, []);

   useEffect(() => {
      if (storedCompanyId && companyList.length > 0) {
         const id = parseInt(storedCompanyId);
         const match = companyList?.find((c) => c.id === id);
         if (match) setCompanyFilter([match.id]);
      }
   }, [companyList]); // eslint-disable-line

   useEffect(() => {
      if (!fromDate) {
         const d = new Date();
         d.setFullYear(d.getFullYear() - 1);
         setFromDate(d.toISOString().split('T')[0]);
      }
   }, [fromDate]);

   const buildParams = useCallback((overrides = {}) => {
      const ids = companyFilter.length > 0
         ? companyFilter
         : localStorage.getItem('companyId') ? [parseInt(localStorage.getItem('companyId'), 10)] : [];
      const validIds = ids.filter((id) => !isNaN(Number(id)) && Number(id) > 0);
      if (!validIds.length) return null;
      return {
         companyIds: validIds.join(','),
         fromDate: dateRange.fromDate,
         toDate: dateRange.toDate,
         orderBy: 'asc',
         search: debouncedSearchQuery,
         ...overrides,
      };
   }, [companyFilter, dateRange, debouncedSearchQuery]);

   useEffect(() => {
      const fetchData = async () => {
         if (!fromDate || !toDate) return;
         setIsLoading(true);
         try {
            const params = buildParams();
            if (params) await dispatch(getInventoryDetailReport(params));
         } catch (err) {
            console.error('Error fetching inventory report:', err);
         } finally {
            setIsLoading(false);
         }
      };
      fetchData();
   }, [dispatch, companyFilter, fromDate, toDate, storedCompanyId, user?.loginhistory?.companyId, debouncedSearchQuery, dateRange]);

   const handleRefresh = useCallback(async () => {
      setIsLoading(true);
      try {
         const params = buildParams();
         if (params) await dispatch(getInventoryDetailReport(params));
      } catch (err) {
         console.error('Error refreshing:', err);
      } finally {
         setIsLoading(false);
      }
   }, [buildParams, dispatch]);

   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((d) => (typeof d === 'string' ? d : d.toISOString().slice(0, 10)));
      setDateRange({ fromDate: from, toDate: to });
   }, []);

   const handleSearchChange = useCallback((e) => {
      const value = e.target.value;
      setSearchQuery(value);
      if (!value.trim()) setDebouncedSearchQuery('');
   }, []);

   useEffect(() => {
      if (!searchQuery.trim()) { setIsSearchLoading(false); return; }
      setIsSearchLoading(true);
      const handler = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
         setIsSearchLoading(false);
      }, 200);
      return () => clearTimeout(handler);
   }, [searchQuery]);

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({ ref: wrapperRef, handler: () => { if (searchQuery === '') setExpanded(false); } });

   useEffect(() => () => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
      if (abortControllerRef.current) abortControllerRef.current.abort();
   }, []);

   const defaultExpandedState = useMemo(() => {
      if (!salesReport?.length) return null;
      const state = {};
      salesReport.forEach((cd) => {
         state[`company-${cd.companyId}`] = true;
         cd.data?.forEach((id) => { state[`item-${id.itemId}`] = true; });
      });
      return state;
   }, [salesReport]);

   useEffect(() => {
      if (defaultExpandedState) setExpandedItems(defaultExpandedState);
   }, [defaultExpandedState]);

   useEffect(() => {
      if (isFirstRenderFilter.current) {
         isFirstRenderFilter.current = false;
         return;
      }
      setIsFilterLoading(false);
   }, [salesReport]);

   useEffect(() => {
      const onKey = (e) => {
         const isInput = ['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName) || e.target.isContentEditable;
         if (e.key.toLowerCase() === 't' && !isInput) fromDateInputRef.current?.focus();
      };
      document.addEventListener('keydown', onKey);
      return () => document.removeEventListener('keydown', onKey);
   }, []);

   const expandAll = useCallback(() => {
      const next = {};
      salesReport.forEach((cd) => {
         next[`company-${cd.companyId}`] = true;
         cd.data?.forEach((id) => { next[`item-${id.itemId}`] = true; });
      });
      setExpandedItems(next); setAllExpanded(true);
   }, [salesReport]);

   const collapseAll = useCallback(() => {
      const next = {};
      salesReport.forEach((cd) => {
         next[`company-${cd.companyId}`] = true;
         cd.data?.forEach((id) => { next[`item-${id.itemId}`] = false; });
      });
      setExpandedItems(next); setAllExpanded(false);
   }, [salesReport]);

   const columnsReportsSalesDetail = useMemo(() => [
      { id: 'date', header: 'Date', accessorKey: 'date' },
      { id: 'docNumber', header: 'Doc#', accessorKey: 'docNumber' },
      { id: 'party', header: 'Account', accessorKey: 'party' },
      { id: 'daybook', header: 'Daybook', accessorKey: 'daybook' },
      { id: 'recqty1', header: 'Receipts Qty 1', accessorKey: 'qty1' },
      { id: 'issqty1', header: 'Issues Qty 1', accessorKey: 'qty1' },
      { id: 'bal1', header: 'Balance Qty 1', accessorKey: 'bal1' },
      { id: 'itemRate', header: 'Rate', accessorKey: 'itemRate' },
   ], []);

   const [columnVisibility, setColumnVisibility] = React.useState(
      () => columnsReportsSalesDetail.reduce((acc, col) => { acc[col.id] = true; return acc; }, {}),
   );

   const generateLast40Months = () => {
      const months = []; const d = new Date();
      for (let i = 0; i < 40; i++) {
         months.push(`${d.toLocaleString('en-US', { month: 'short' })} ${d.getFullYear()}`);
         d.setMonth(d.getMonth() - 1);
      }
      return months;
   };

   const formatDateToDDMMYYYY = useCallback((ds) => {
      if (!ds) return '-';
      const d = new Date(ds);
      if (isNaN(d.getTime())) return '-';
      return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
   }, []);

   const exportToExcel = useCallback(() => {
      if (!salesReport?.length) { alert('No data to export'); return; }
      try {
         const wb = XLSX.utils.book_new();
         const S = {
            title: { font: { bold: true, sz: 16 }, alignment: { horizontal: 'center' } },
            date: { font: { italic: true, sz: 12 }, alignment: { horizontal: 'center' } },
            company: { fill: { fgColor: { rgb: 'F1E7E7' } }, font: { bold: true, sz: 14 }, alignment: { horizontal: 'left' } },
            item: { fill: { fgColor: { rgb: 'F8FAFC' } }, font: { bold: true, sz: 12 }, alignment: { horizontal: 'left' } },
            thead: { fill: { fgColor: { rgb: 'F5F5F5' } }, font: { bold: true, sz: 11 }, alignment: { horizontal: 'center' }, border: { top: { style: 'thin', color: { rgb: '000000' } }, bottom: { style: 'thin', color: { rgb: '000000' } }, left: { style: 'thin', color: { rgb: '000000' } }, right: { style: 'thin', color: { rgb: '000000' } } } },
            odd: { fill: { fgColor: { rgb: 'FFFFFF' } }, font: { sz: 11 } },
            even: { fill: { fgColor: { rgb: 'EFF6FF' } }, font: { sz: 11 } },
            num: { numFmt: '#,##0.00' },
            cur: { numFmt: '"₹"#,##0.00' },
         };
         const rows = [];
         rows.push([{ v: 'Inventory Detail Report', s: S.title }]);
         rows.push([{ v: `From ${formatDateToDDMMYYYY(dateRange?.fromDate || fromDate)} to ${formatDateToDDMMYYYY(dateRange?.toDate || toDate)}`, s: S.date }]);
         rows.push([]);
         salesReport.forEach((cd) => {
            const ct = calculateCompanyTotals(cd);
            rows.push([{ v: cd.companyName, s: S.company }, { v: '', s: S.company }, { v: 'Grand Total', s: { ...S.company, alignment: { horizontal: 'center' } } }, { v: '', s: S.company },
            { v: ct.receiptQtyTotal, t: 'n', s: { ...S.company, ...S.num, alignment: { horizontal: 'right' } } },
            { v: ct.issueQtyTotal, t: 'n', s: { ...S.company, ...S.num, alignment: { horizontal: 'right' } } },
            { v: ct.balanceTotal, t: 'n', s: { ...S.company, ...S.num, alignment: { horizontal: 'right' } } },
            { v: ct.rateTotal, t: 'n', s: { ...S.company, ...S.cur, alignment: { horizontal: 'right' } } },
            ]);
            rows.push([]);
            cd.data.forEach((id) => {
               const it = calculateItemTotals(id);
               rows.push([{ v: `Item: ${id.itemName}`, s: S.item }, { v: '', s: S.item }, { v: 'Item Total', s: { ...S.item, alignment: { horizontal: 'center' } } }, { v: '', s: S.item },
               { v: it.receiptQtyTotal, t: 'n', s: { ...S.item, ...S.num, alignment: { horizontal: 'right' } } },
               { v: it.issueQtyTotal, t: 'n', s: { ...S.item, ...S.num, alignment: { horizontal: 'right' } } },
               { v: id.totalBal1, t: 'n', s: { ...S.item, ...S.num, alignment: { horizontal: 'right' } } },
               { v: it.rateTotal, t: 'n', s: { ...S.item, ...S.cur, alignment: { horizontal: 'right' } } },
               ]);
               rows.push(columnsReportsSalesDetail.map((c) => ({ v: c.header, s: S.thead })));
               if (cd[0]?.totalOpeningBal1 > 0) rows.push([{ v: '', s: S.even }, { v: '', s: S.even }, { v: 'Opening Balance', s: { ...S.even, font: { bold: true, sz: 12 } } }, { v: '', s: S.even }, { v: '', s: S.even }, { v: '', s: S.even }, { v: cd[0].totalOpeningBal1, t: 'n', s: { ...S.even, ...S.num } }, { v: '', s: S.even }]);
               id.data.forEach((t, i) => {
                  const rs = i % 2 === 0 ? S.even : S.odd;
                  rows.push([
                     { v: t.transactionAt ? formatDateToDDMMYYYY(t.transactionAt) : '', s: rs },
                     { v: `${t.prefix || ''}${t.docno || ''}${t.postFix || ''}` || '-', s: rs }, { v: t.accountName || '', s: rs }, { v: t.daybookName || '', s: rs },
                     { v: t.qty1 > 0 ? t.qty1 : '', t: 'n', s: { ...rs, ...S.num } },
                     { v: t.qty1 < 0 ? Math.abs(t.qty1) : '', t: 'n', s: { ...rs, ...S.num } },
                     { v: t.bal1 !== undefined ? t.bal1 : '', t: 'n', s: { ...rs, ...S.num } },
                     { v: t.itemRate !== undefined ? t.itemRate : '', t: 'n', s: { ...rs, ...S.cur } },
                  ]);
               });
               rows.push([]);
            });
            rows.push([]);
         });
         const ws = XLSX.utils.aoa_to_sheet(rows);
         ws['!cols'] = [{ wch: 12 }, { wch: 15 }, { wch: 25 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }];
         ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, { s: { r: 1, c: 0 }, e: { r: 1, c: 7 } }];
         let mr = 3;
         salesReport.forEach((cd) => {
            ws['!merges'].push({ s: { r: mr, c: 0 }, e: { r: mr, c: 1 } }); mr += 2;
            cd.data.forEach((id) => {
               ws['!merges'].push({ s: { r: mr, c: 0 }, e: { r: mr, c: 1 } });
               mr += 1 + (id.data?.length || 0) + 1;
               if (cd[0]?.totalOpeningBal1 > 0) mr += 1;
            });
            mr += 1;
         });
         XLSX.utils.book_append_sheet(wb, ws, 'Inventory Detail');
         const n = new Date();
         XLSX.writeFile(wb, `Inventory_Detail_${n.getFullYear()}${String(n.getMonth() + 1).padStart(2, '0')}${String(n.getDate()).padStart(2, '0')}.xlsx`);
      } catch (e) { console.error(e); alert('Failed to export Excel.'); }
   }, [salesReport, dateRange, fromDate, toDate, formatDateToDDMMYYYY, columnsReportsSalesDetail]);

   const exportToPDF = useCallback(() => {
      if (!salesReport?.length) { alert('No data to export'); return; }
      try {
         const doc = new jsPDF({ orientation: 'landscape', unit: 'mm' });
         doc.setFontSize(16); doc.setFont('helvetica', 'bold');
         doc.text('Inventory Detail Report', 140, 10, { align: 'center' });
         doc.setFontSize(12); doc.setFont('helvetica', 'normal');
         doc.text(`From ${formatDateToDDMMYYYY(dateRange?.fromDate || fromDate)} to ${formatDateToDDMMYYYY(dateRange?.toDate || toDate)}`, 140, 18, { align: 'center' });
         let startY = 30;
         const hdrs = columnsReportsSalesDetail.map((c) => c.header);
         salesReport.forEach((cd, ci) => {
            const ct = calculateCompanyTotals(cd);
            const companyRow = [[{ content: `${cd.companyName} (Total)`, styles: { fontStyle: 'bold' } }, '', '',
               '', { content: ct.receiptQtyTotal.toString(), styles: { halign: 'right' } }, { content: ct.issueQtyTotal.toString(), styles: { halign: 'right' } },
            { content: ct.balanceTotal.toString(), styles: { halign: 'right' } }, { content: ct.rateTotal.toString(), styles: { halign: 'right' } }]];
            if (ci > 0) startY += 5;
            cd.data.forEach((id, ii) => {
               const it = calculateItemTotals(id);
               const itemRow = [[{ content: `${id.itemName} (Total)`, styles: { fontStyle: 'bold' } }, '', '',
                  '', { content: it.receiptQtyTotal.toString(), styles: { halign: 'right' } }, { content: it.issueQtyTotal.toString(), styles: { halign: 'right' } },
               { content: id.totalBal1.toString(), styles: { halign: 'right' } }, { content: it.rateTotal.toString(), styles: { halign: 'right' } }]];
               const txRows = [];
               if (id.totalOpeningBal1 > 0) txRows.push(['', '', 'Opening Balance', '', '', '', { content: id.totalOpeningBal1.toString(), styles: { halign: 'right', fontStyle: 'bold' } }, '']);
               id.data.forEach((t) => txRows.push([
                  t.transactionAt ? formatDateToDDMMYYYY(t.transactionAt) : '', `${t.prefix || ''}${t.docno || ''}${t.postFix || ''}` || '-', t.accountName || '', t.daybookName || '',
                  t.qty1 > 0 ? { content: t.qty1.toString(), styles: { halign: 'right' } } : '',
                  t.qty1 < 0 ? { content: Math.abs(t.qty1).toString(), styles: { halign: 'right' } } : '',
                  t.bal1 !== undefined ? { content: t.bal1.toString(), styles: { halign: 'right' } } : '',
                  t.itemRate !== undefined ? { content: t.itemRate.toString(), styles: { halign: 'right' } } : '',
               ]));
               doc.autoTable({
                  head: [hdrs], body: [...(ii === 0 ? companyRow : []), ...itemRow, ...txRows],
                  startY, margin: { left: 10, right: 10 },
                  styles: { fontSize: 8 },
                  headStyles: { fillColor: [245, 245, 245], textColor: 0, fontStyle: 'bold', fontSize: 8 },
                  alternateRowStyles: { fillColor: [239, 246, 255] },
                  columnStyles: { 0: { halign: 'center' }, 1: { halign: 'center' }, 2: { halign: 'left' }, 3: { halign: 'left' }, 4: { halign: 'right' }, 5: { halign: 'right' }, 6: { halign: 'right' }, 7: { halign: 'right' } },
                  didParseCell: (d) => {
                     if (d.row.raw[0]?.content?.includes('(Total)')) {
                        d.cell.styles.fillColor = d.row.raw[0].content.includes(cd.companyName) ? [241, 231, 231] : [248, 250, 252];
                        d.cell.styles.fontStyle = 'bold';
                     }
                     if (d.section === 'head' && d.column.index >= 4) d.cell.styles.halign = 'right';
                  },
                  didDrawPage: (d) => { startY = d.cursor.y + 2; },
               });
            });
            if (ci < salesReport.length - 1) { doc.addPage('landscape'); startY = 20; }
         });
         const n = new Date();
         doc.save(`Inventory_Detail_${n.getFullYear()}${String(n.getMonth() + 1).padStart(2, '0')}${String(n.getDate()).padStart(2, '0')}.pdf`);
      } catch (e) { console.error(e); alert('Failed to export PDF.'); }
   }, [salesReport, dateRange, fromDate, toDate, formatDateToDDMMYYYY, columnsReportsSalesDetail]);

   const calculateOverallGrandTotals = useCallback(() => {
      if (!salesReport || salesReport.length === 0 || companyFilter.length <= 1) {
         return null;
      }

      const overallTotals = {
         totalReceiptQty: 0,
         totalIssueQty: 0,
         totalBalanceQty: 0,
         totalRate: 0,
         companyCount: companyFilter.length,
      };

      salesReport.forEach((companyData) => {
         if (!companyData?.data) return;

         companyData.data.forEach((itemData) => {
            if (!itemData?.data) return;

            itemData.data.forEach((transaction) => {
               const qty = Number(transaction.qty1) || 0;
               const rate = Number(transaction.itemRate) || 0;
               const balance = Number(transaction.bal1) || 0;

               if (qty > 0) overallTotals.totalReceiptQty += qty;
               else if (qty < 0) overallTotals.totalIssueQty += Math.abs(qty);

               overallTotals.totalRate += rate;
               overallTotals.totalBalanceQty += balance;
            });
         });
      });

      return overallTotals;
   }, [salesReport, companyFilter]);

   const OverallGrandTotalHeader = React.memo(({ totals }) => {
      const { colorMode } = useColorMode();
      const isDark = colorMode === 'dark';

      const bgColor = isDark ? '#2D2A14' : '#FEFCE8';
      const borderColor = isDark ? '#CA8A04' : '#A16207';

      if (!totals) return null;

      return (
         <Tr
            bg={bgColor}
            borderTop="2px solid"
            borderBottom="2px solid"
            borderColor={borderColor}>
            {/* Column 3: Account - GRAND TOTAL label with Account column width */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               fontSize="14px"
               fontWeight={800}
               color={isDark ? '#FDE047' : '#713F12'}
               whiteSpace="nowrap"
               textTransform="uppercase"
               letterSpacing="0.5px">
               GRAND TOTAL ({totals.companyCount} Companies)
            </Td>

            {/* Column 1: Date - empty but styled to maintain table structure */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               style={{ width: COL_PX.date + 'px' }} />

            {/* Column 2: Doc# - empty */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               style={{ width: COL_PX.docno + 'px' }} />


            {/* Column 4: Daybook - empty but maintains structure */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               style={{ width: COL_PX.daybook + 'px' }} />
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               style={{ width: COL_PX.date + 'px' }} />

            {/* Column 2: Doc# - empty */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               style={{ width: COL_PX.docno + 'px' }} />


            {/* Column 4: Daybook - empty but maintains structure */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               style={{ width: COL_PX.daybook + 'px' }} />
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               style={{ width: COL_PX.date + 'px' }} />

            {/* Column 2: Doc# - empty */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               style={{ width: COL_PX.docno + 'px' }} />

            {/* Column 5: Receipts Qty */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               fontSize="14px"
               fontWeight={700}
               color={isDark ? 'green.300' : 'green.700'}
               isNumeric
               style={{ width: COL_PX.recqty + 'px' }}>
               {totals.totalReceiptQty.toLocaleString('en-IN')}
            </Td>

            {/* Column 6: Issues Qty */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               fontSize="14px"
               fontWeight={700}
               color={isDark ? 'red.300' : 'red.700'}
               isNumeric
               style={{ width: COL_PX.issqty + 'px' }}>
               {totals.totalIssueQty.toLocaleString('en-IN')}
            </Td>

            {/* Column 7: Balance Qty */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               fontSize="14px"
               fontWeight={700}
               color={isDark ? 'purple.300' : 'purple.700'}
               isNumeric
               style={{ width: COL_PX.balqty + 'px' }}>
               {totals.totalBalanceQty.toLocaleString('en-IN')}
            </Td>

            {/* Column 8: Rate */}
            <Td
               borderColor={isDark ? 'gray.600' : 'gray.300'}
               p="10px"
               py="12px"
               fontSize="14px"
               fontWeight={700}
               color={isDark ? 'gray.200' : 'gray.800'}
               isNumeric
               style={{ width: COL_PX.rate + 'px' }}>
               ₹{totals.totalRate.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
            </Td>
         </Tr>
      );
   });

   const formatCurrencyWithSmallDecimal = useCallback((value, showRupeeSymbol = false) => {
      if (value === null || value === undefined || value === '') return showRupeeSymbol ? '₹-' : '-';
      const n = Number(value);
      if (isNaN(n)) return showRupeeSymbol ? '₹' + String(value) : String(value);
      const fmt = Math.abs(n).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const parts = fmt.split('.');
      if (parts.length === 2) { const el = <>{parts[0]}.<span style={{ fontSize: '10px' }}>{parts[1]}</span></>; return showRupeeSymbol ? <>₹{el}</> : el; }
      return showRupeeSymbol ? <>₹{fmt}</> : fmt;
   }, []);

   const renderDataRows = useCallback((itemData, companyData) => {
      if (!itemData || !Array.isArray(itemData)) return null;
      const handledata = async (data) => {
         const cId = parseInt(localStorage.getItem('companyId'));
         if (data.companyId === cId && data.daybookType === 20 && (admin || rights?.inventoryreceive?.view)) { setEntityType('receivemaster'); const r = await dispatch(getReceiveInventory(data.headerId)); await dispatch(getAccountById({ id: r?.accountId, compId: user?.loginhistory?.companyId })); setIsOpenSingleViewinr(true); }
         if (data.companyId === cId && data.daybookType === 19 && (admin || rights?.inventoryissue?.view)) { setEntityType('issuemaster'); const r = await dispatch(getIssueInventory(data.headerId)); await dispatch(getAccountById({ id: r?.accountId, compId: user?.loginhistory?.companyId })); setIsOpenSingleViewinr(true); }
         if (data.companyId === cId && data.daybookType === 11 && (admin || rights?.purchaseinvoice?.view)) { setEntityType('purchaseinvoice'); await dispatch(getPurchaseInvoice(data.headerId)); setIsOpenPurchaseReturnSingleView(true); }
         if (data.companyId === cId && data.daybookType === 5 && (admin || rights?.saleinvoice?.view)) { setEntityType('saleinvoice'); await dispatch(getSaleInvoice(data.headerId)); setIsOpenPurchaseReturnSingleView(true); }
         if (data.companyId === cId && data.daybookType === 12 && (admin || rights?.purchasereturn?.view)) { setEntityType('purchasereturn'); await dispatch(getSinglePurchaseReturn(data.id)); await dispatch(getSinglePurchaseReturnWithPrevAndNext({ id: data.headerId, page: 1, limit: 1, sortBy: 'id', sortOrder: 'desc' })); setIsOpenPurchaseReturnSingleView(true); }
         if (data.companyId === cId && data.daybookType === 6 && (admin || rights?.salereturn?.view)) { setEntityType('salereturn'); await dispatch(getSingleSalesReturnWithPrevAndNext({ id: data.headerId, page: 1, limit: 1, sortBy: 'id', sortOrder: 'desc' })); setIsOpenPurchaseReturnSingleView(true); }
      };
      const useVirtualization = itemData.length >= 50;

      // Common cell styles
      const thStyle = {
         borderColor: isDark ? 'gray.600' : 'gray.300',
         p: '8px', py: '12px',
         fontSize: '12px', fontWeight: '700',
         color: isDark ? 'blue.200' : 'blue.800',
         whiteSpace: 'nowrap', textTransform: 'uppercase', letterSpacing: '0.5px',
      };

      return (
         <>
            {/* ── Sub-header row (8 cells, colgroup drives widths) ── */}
            <Tr bg={isDark ? 'gray.700' : 'blue.50'} borderTop="2px solid" borderColor={isDark ? 'blue.400' : 'blue.300'}>
               <Th {...thStyle}>Date</Th>
               <Th {...thStyle}>Doc#</Th>
               <Th {...thStyle}>Account</Th>
               <Th {...thStyle}>Daybook</Th>
               <Th {...thStyle} isNumeric>Receipts Qty</Th>
               <Th {...thStyle} isNumeric>Issues Qty</Th>
               <Th {...thStyle} isNumeric>Balance Qty</Th>
               <Th {...thStyle} isNumeric>Rate</Th>
            </Tr>

            {/* ── Opening balance (non-virtualized) ── */}
            {!useVirtualization && companyData[0]?.totalOpeningBal1 > 0 && (
               <Tr bg={isDark ? '#2D3748' : '#FFFBEB'} borderLeft="3px solid" borderColor={isDark ? '#D97706' : '#92400E'}>
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" />
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" />
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px"
                     fontSize="14px" fontWeight={700} color={isDark ? '#FCD34D' : '#78350F'} whiteSpace="nowrap">
                     Opening Balance
                  </Td>
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" />
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" />
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" />
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px"
                     fontSize="14px" fontWeight={700} color={isDark ? '#FCD34D' : '#78350F'} isNumeric>
                     {formatCurrencyWithSmallDecimal(companyData[0].totalOpeningBal1)}
                  </Td>
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" />
               </Tr>
            )}

            {/* ── Data rows ── */}
            {useVirtualization ? (
               <Tr>
                  <Td colSpan={8} p={0} border="none">
                     <VirtualizedTransactionRows
                        transactions={itemData}
                        columnsReportsSalesDetail={columnsReportsSalesDetail}
                        isDark={isDark}
                        formatCurrencyWithSmallDecimal={formatCurrencyWithSmallDecimal}
                        formatDateToDDMMYYYY={formatDateToDDMMYYYY}
                        handledata={handledata}
                        companyData={companyData}
                     />
                  </Td>
               </Tr>
            ) : (
               itemData.map((t, ri) => (
                  <Tr key={`row-${ri}`}
                     bg={ri % 2 === 0 ? (isDark ? '#1A202C' : '#FFFFFF') : (isDark ? '#171E2E' : '#F7FAFC')}
                     _hover={{ bg: isDark ? '#2D3748' : '#EBF8FF' }}
                     onClick={() => handledata(t)}
                     cursor="pointer"
                     transition="background 0.15s">
                     <Td borderColor={isDark ? 'gray.700' : 'gray.200'} p="8px" py="10px"
                        fontSize="13px" fontWeight={500} color={isDark ? 'gray.300' : 'gray.700'} whiteSpace="nowrap">
                        {t.transactionAt ? formatDateToDDMMYYYY(t.transactionAt) : ''}
                     </Td>
                     <Td borderColor={isDark ? 'gray.700' : 'gray.200'} p="8px" py="10px"
                        fontSize="13px" fontWeight={600} color={isDark ? 'blue.300' : 'blue.700'} whiteSpace="nowrap">
                        {`${t.prefix || ''}${t.docno || ''}${t.postFix || ''}` || '-'}
                     </Td>
                     <Td borderColor={isDark ? 'gray.700' : 'gray.200'} p="8px" py="10px"
                        fontSize="13px" fontWeight={500} color={isDark ? 'gray.200' : 'gray.800'} whiteSpace="nowrap"
                        maxW="0" overflow="hidden" textOverflow="ellipsis">
                        {t.accountName || ''}
                     </Td>
                     <Td borderColor={isDark ? 'gray.700' : 'gray.200'} p="8px" py="10px"
                        fontSize="13px" fontWeight={500} color={isDark ? 'gray.400' : 'gray.600'} whiteSpace="nowrap"
                        overflow="hidden" textOverflow="ellipsis">
                        {t.daybookName || ''}
                     </Td>
                     <Td borderColor={isDark ? 'gray.700' : 'gray.200'} p="8px" py="10px"
                        fontSize="13px" fontWeight={600} color={isDark ? 'green.300' : 'green.600'} isNumeric whiteSpace="nowrap">
                        {t.qty1 !== undefined && t.qty1 > 0 ? formatCurrencyWithSmallDecimal(t.qty1) : '-'}
                     </Td>
                     <Td borderColor={isDark ? 'gray.700' : 'gray.200'} p="8px" py="10px"
                        fontSize="13px" fontWeight={600} color={isDark ? 'red.300' : 'red.600'} isNumeric whiteSpace="nowrap">
                        {t.qty1 !== undefined && t.qty1 < 0 ? formatCurrencyWithSmallDecimal(Math.abs(t.qty1)) : '-'}
                     </Td>
                     <Td borderColor={isDark ? 'gray.700' : 'gray.200'} p="8px" py="10px"
                        fontSize="13px" fontWeight={600} color={isDark ? 'purple.300' : 'purple.700'} isNumeric whiteSpace="nowrap">
                        {t.bal1 !== undefined ? formatCurrencyWithSmallDecimal(t.bal1) : ''}
                     </Td>
                     <Td borderColor={isDark ? 'gray.700' : 'gray.200'} p="8px" py="10px"
                        fontSize="13px" fontWeight={500} color={isDark ? 'gray.300' : 'gray.700'} isNumeric whiteSpace="nowrap">
                        {t.itemRate !== undefined ? formatCurrencyWithSmallDecimal(t.itemRate, true) : ''}
                     </Td>
                  </Tr>
               ))
            )}
         </>
      );
   }, [isDark, columnsReportsSalesDetail, formatCurrencyWithSmallDecimal, formatDateToDDMMYYYY, dispatch, user]);

   const calculateItemTotals = useCallback((itemData) => {
      if (!itemData?.data || !Array.isArray(itemData.data)) return { receiptQtyTotal: 0, issueQtyTotal: 0, rateTotal: 0, balanceTotal: 0 };
      return itemData.data.reduce((acc, t) => {
         const q = Number(t.qty1) || 0, r = Number(t.itemRate) || 0, b = Number(t.bal1) || 0;
         if (q > 0) acc.receiptQtyTotal += q; else if (q < 0) acc.issueQtyTotal += Math.abs(q);
         if (r > 0) acc.rateTotal += r; if (b !== 0) acc.balanceTotal += b;
         return acc;
      }, { receiptQtyTotal: 0, issueQtyTotal: 0, rateTotal: 0, balanceTotal: 0 });
   }, []);

   const calculateCompanyTotals = useCallback((cd) => {
      if (!cd?.data || !Array.isArray(cd.data)) return { receiptQtyTotal: 0, issueQtyTotal: 0, rateTotal: 0, balanceTotal: 0 };
      return cd.data.reduce((acc, id) => {
         const t = calculateItemTotals(id);
         return { receiptQtyTotal: acc.receiptQtyTotal + t.receiptQtyTotal, issueQtyTotal: acc.issueQtyTotal + t.issueQtyTotal, rateTotal: acc.rateTotal + t.rateTotal, balanceTotal: acc.balanceTotal + t.balanceTotal };
      }, { receiptQtyTotal: 0, issueQtyTotal: 0, rateTotal: 0, balanceTotal: 0 });
   }, [calculateItemTotals]);

   const memoizedReportContent = useMemo(() => {
      if (!salesReport || !Array.isArray(salesReport)) return null;
      if (isLoading) return <Tr><Td colSpan={8} textAlign="center" py="100px"><Loader /></Td></Tr>;

      // Calculate overall grand totals
      const overallTotals = calculateOverallGrandTotals();

      return (
         <>
            {/* Overall Grand Total Header - Only show when multiple companies selected */}
            {overallTotals && (
               <Tr>
                  <Td colSpan={8} p={0} border="none">
                     <OverallGrandTotalHeader totals={overallTotals} />
                  </Td>
               </Tr>
            )}

            {salesReport.map((cd, ci) => {
               const ct = calculateCompanyTotals(cd);
               return (
                  <React.Fragment key={`company-${cd.companyId || ci}`}>
                     {/* Company header row */}
                     <Tr
                        bg={isDark ? 'linear-gradient(135deg,#1e3a8a 0%,#1e40af 100%)' : 'linear-gradient(135deg,#dbeafe 0%,#bfdbfe 100%)'}
                        cursor="pointer"
                        onClick={() => toggleExpand(`company-${cd.companyId}`)}
                        borderLeft="4px solid"
                        borderLeftColor={isDark ? 'blue.400' : 'blue.600'}
                        boxShadow={isDark ? '0 2px 8px rgba(59,130,246,0.3)' : '0 2px 8px rgba(59,130,246,0.15)'}
                        transition="all 0.3s"
                        _hover={{ bg: isDark ? 'linear-gradient(135deg,#1e40af 0%,#2563eb 100%)' : 'linear-gradient(135deg,#bfdbfe 0%,#93c5fd 100%)', transform: 'translateX(4px)' }}>
                        <Td p="10px" py="14px" colSpan={8} color={isDark ? 'white' : 'blue.900'}>
                           <Flex justifyContent="space-between" alignItems="center">
                              <Text fontWeight="800" fontSize="15px" letterSpacing="0.5px">{cd.companyName}</Text>
                              <Box bg={isDark ? 'blue.500' : 'blue.600'} borderRadius="full" p="4px">
                                 {expandedItems[`company-${cd.companyId}`]
                                    ? <ChevronUpIcon boxSize="20px" color="white" />
                                    : <ChevronDownIcon boxSize="20px" color="white" />}
                              </Box>
                           </Flex>
                        </Td>
                     </Tr>

                     {expandedItems[`company-${cd.companyId}`] && cd.data?.map((id, ii) => {
                        const it = calculateItemTotals(id);
                        return (
                           <React.Fragment key={`item-${id.itemId || ii}`}>
                              {/* Item header row */}
                              <Tr
                                 bg={isDark ? '#252D3D' : '#EEF2FF'}
                                 cursor="pointer"
                                 onClick={() => toggleExpand(`item-${id.itemId}`)}
                                 borderLeft="3px solid"
                                 borderLeftColor={isDark ? '#818CF8' : '#4F46E5'}
                                 transition="all 0.2s"
                                 _hover={{ bg: isDark ? '#2D3748' : '#E0E7FF' }}>
                                 <Td p="10px" py="12px" borderColor={isDark ? 'gray.600' : 'gray.300'}
                                    color={isDark ? '#A5B4FC' : '#3730A3'} overflow="hidden" whiteSpace="nowrap">
                                    <Text fontWeight="700" fontSize="14px">Item :</Text>
                                 </Td>
                                 <Td p="10px" py="12px" borderColor={isDark ? 'gray.600' : 'gray.300'} />
                                 <Td p="10px" py="12px" borderColor={isDark ? 'gray.600' : 'gray.300'}
                                    color={isDark ? '#A5B4FC' : '#3730A3'} overflow="hidden"
                                    maxW="0" whiteSpace="nowrap" textOverflow="ellipsis">
                                    <Text fontWeight="700" fontSize="14px">{id.itemName}</Text>
                                 </Td>
                                 <Td p="10px" py="12px" borderColor={isDark ? 'gray.600' : 'gray.300'}
                                    fontSize="13px" fontWeight={700} color={isDark ? 'gray.300' : 'gray.600'} whiteSpace="nowrap">
                                    Item Total
                                 </Td>
                                 <Td p="10px" py="12px" borderColor={isDark ? 'gray.600' : 'gray.300'}
                                    fontSize="14px" fontWeight={700}
                                    color={isDark ? 'green.300' : 'green.700'} isNumeric whiteSpace="nowrap">
                                    {formatCurrencyWithSmallDecimal(it.receiptQtyTotal)}
                                 </Td>
                                 <Td p="10px" py="12px" borderColor={isDark ? 'gray.600' : 'gray.300'}
                                    fontSize="14px" fontWeight={700}
                                    color={isDark ? 'red.300' : 'red.700'} isNumeric whiteSpace="nowrap">
                                    {it.issueQtyTotal > 0 ? formatCurrencyWithSmallDecimal(-it.issueQtyTotal) : '-'}
                                 </Td>
                                 <Td p="10px" py="12px" borderColor={isDark ? 'gray.600' : 'gray.300'}
                                    fontSize="14px" fontWeight={700}
                                    color={isDark ? 'purple.300' : 'purple.700'} isNumeric whiteSpace="nowrap">
                                    {formatCurrencyWithSmallDecimal(id?.totalBal1 || 0)}
                                 </Td>
                                 <Td p="10px" py="12px" borderColor={isDark ? 'gray.600' : 'gray.300'}
                                    fontSize="14px" fontWeight={700}
                                    color={isDark ? 'gray.300' : 'gray.700'} isNumeric whiteSpace="nowrap">
                                    <Flex alignItems="center" justifyContent="flex-end" gap="6px">
                                       {it.rateTotal > 0 ? formatCurrencyWithSmallDecimal(it.rateTotal, true) : '-'}
                                       <Box bg={isDark ? '#6366F1' : '#4F46E5'} borderRadius="full" p="2px" flexShrink={0}>
                                          {expandedItems[`item-${id.itemId}`]
                                             ? <ChevronUpIcon boxSize="16px" color="white" />
                                             : <ChevronDownIcon boxSize="16px" color="white" />}
                                       </Box>
                                    </Flex>
                                 </Td>
                              </Tr>

                              {expandedItems[`item-${id.itemId}`] && id.data?.length > 0
                                 && renderDataRows(id.data, cd.data)}
                           </React.Fragment>
                        );
                     })}

                     {/* Company Grand Total row */}
                     {expandedItems[`company-${cd.companyId}`] && (
                        <Tr bg={isDark ? '#2D2A14' : '#FEFCE8'}
                           borderTop="2px solid" borderBottom="2px solid"
                           borderColor={isDark ? '#CA8A04' : '#A16207'}>
                           <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px" />
                           <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px" />
                           <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px" />
                           <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px"
                              fontSize="14px" fontWeight={800}
                              color={isDark ? '#FDE047' : '#713F12'}
                              whiteSpace="nowrap" textTransform="uppercase" letterSpacing="0.5px">
                              Company Total
                           </Td>
                           <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px"
                              fontSize="14px" fontWeight={700}
                              color={isDark ? 'green.300' : 'green.700'} isNumeric whiteSpace="nowrap">
                              {formatCurrencyWithSmallDecimal(ct.receiptQtyTotal)}
                           </Td>
                           <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px"
                              fontSize="14px" fontWeight={700}
                              color={isDark ? 'red.300' : 'red.700'} isNumeric whiteSpace="nowrap">
                              {formatCurrencyWithSmallDecimal(-ct.issueQtyTotal)}
                           </Td>
                           <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px"
                              fontSize="14px" fontWeight={700}
                              color={isDark ? 'purple.300' : 'purple.700'} isNumeric whiteSpace="nowrap">
                              {formatCurrencyWithSmallDecimal(ct.balanceTotal)}
                           </Td>
                           <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px"
                              fontSize="14px" fontWeight={700}
                              color={isDark ? 'gray.200' : 'gray.800'} isNumeric whiteSpace="nowrap">
                              {formatCurrencyWithSmallDecimal(ct.rateTotal, true)}
                           </Td>
                        </Tr>
                     )}
                  </React.Fragment>
               );
            })}
         </>
      );
   }, [
      salesReport,
      expandedItems,
      isLoading,
      isDark,
      toggleExpand,
      calculateItemTotals,
      calculateCompanyTotals,
      calculateOverallGrandTotals,
      renderDataRows,
      formatCurrencyWithSmallDecimal
   ]);

   const handleViewSingleData = useCallback(async (id) => { await dispatch(getReceiveInventory(id)); setIsOpenSingleViewinr(true); }, [dispatch]);
   const handleSalesSingleDataViewClose = useCallback(() => setIsOpenSingleViewinr(), []);
   const handleSalesDetailsClose = useCallback(() => setIsOpenPurchaseReturnSingleView(), []);

   const deletePurchaseReturn = useCallback(() => {
      if (entityType === 'purchasereturn') deleteRecord(viewDetail?.id, deletePurchaseReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      if (entityType === 'salereturn') deleteRecord(viewDetail?.id, deleteSaleReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      if (entityType === 'saleinvoice') deleteRecordForSales(viewDetail?.id, viewDetail?.daybookId, viewDetail?.accountId, deleteSaleInvoice, dispatch, storedCompanyId, userGlobalSettingsData);
      if (entityType === 'purchaseinvoice') deleteRecordForSales(viewDetail?.id, viewDetail?.daybookId, viewDetail?.accountId, deletePurchaseInvoice, dispatch, storedCompanyId, userGlobalSettingsData);
      setIsOpenPurchaseReturnSingleView(false);
   }, [entityType, viewDetail, dispatch, user, userGlobalSettingsData, storedCompanyId]);

   useEffect(() => {
      if (account) setDynamicUserDetails([
         { label: 'Bill To', value: account?.name || '-' }, { label: 'Mobile', value: account?.mobile || '-' },
         { label: 'PAN', value: account?.panNo || '-' }, { label: 'Billing Address', value: account?.address || '-' },
      ]);
   }, [account]);

   return (
      <>
         <Flex pr="25px" mb="8px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img src={back} alt="Go Back" width="15px" onClick={() => window.history.back()} style={{ cursor: 'pointer' }} />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>Inventory Detail</Text>
            </Flex>
            <Flex gap={2}>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>Expand All</Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>Collapse All</Button>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center">
               <Box flex="" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
                  <div flex="1" mr={''} justifyContent="center">
                     <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} mt={5} display={{ base: 'none', xl: 'block' }}>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown('company', 'Company', lastcompanyOptions, { value: companyFilter, onChange: handleCompanyChange }, {}, textColor, false, 'Select company', true, undefined, true)}
                        </GridItem>
                     </Box>
                  </div>
               </Box>
               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]} onChange={handleDateRangeChange} defaultPeriod="thisFinancialYear" style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }} />
                  </Flex>
               </Flex>
               <Flex flex="1"></Flex>
               <Box flex="" mr={3}>
                  <MotionFlex ref={wrapperRef} align="center" bg={bg} borderRadius="full" cursor="pointer"
                     px={expanded ? 3 : 0} w={expanded ? '250px' : '40px'} h="40px" transition="all 0.3s ease" onClick={() => setExpanded(true)}>
                     <MotionSearchIcon color={icon} animate={{ rotate: expanded ? 0 : 90 }} transition={{ duration: 0.3 }} style={{ marginRight: expanded ? '8px' : '10px', marginLeft: expanded ? '0' : '10px' }} />
                     {expanded && (
                        <InputGroup width="200px">
                           <Input placeholder="Search accounts..." value={searchQuery} onChange={handleSearchChange} color={icon} variant="unstyled" _focus={{ outline: 'none' }} />
                           {isSearchLoading && <Spinner size="sm" color="blue.500" ml={2} />}
                        </InputGroup>
                     )}
                  </MotionFlex>
               </Box>
               <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}><LuRefreshCcw size={20} mr={2} /></Button>
               <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}><IoFilterOutline size={22} /></Button>
               <Popover>
                  <PopoverTrigger><img src={Download} alt="Download" width="25" style={{ cursor: 'pointer' }} /></PopoverTrigger>
                  <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                     <PopoverBody p="3">
                        <Button width="100%" variant="ghost" _hover={{ bg: 'blue.100' }} onClick={exportToExcel} justifyContent="space-between" mb={3}><img src={xls} alt="XLS" width="30px" />Download Excel</Button>
                        <Button width="100%" variant="ghost" _hover={{ bg: 'blue.100' }} onClick={exportToPDF} justifyContent="space-between"><img src={xls} alt="PDF" width="30px" mr />Download PDF</Button>
                     </PopoverBody>
                  </PopoverContent>
               </Popover>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}><Image src={DotIcon} alt="Menu" width="25px" /></Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown('company', 'Company', lastcompanyOptions, { value: companyFilter, onChange: handleCompanyChange }, {}, textColor, false, 'Select company', true, undefined, true)}
                        </GridItem>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]} onChange={handleDateRangeChange} defaultPeriod="thisFinancialYear" style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }} />
                        </Box>
                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>Apply Filters</Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box overflowX="auto" className="custom-scrollbar" position="relative"
                  minH={{ base: '70vh', md: '70vh', xl: '75vh' }} maxH={{ base: '70vh', md: '70vh', xl: '75vh' }}>
                  {isFilterLoading && (
                     <Box
                        position="fixed"
                        top={0} left={0} right={0} bottom={0}
                        zIndex={9999}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg={isDark ? 'rgba(10,20,50,0.60)' : 'rgba(255,255,255,0.60)'}
                        backdropFilter="blur(3px)"
                     >
                        <Flex direction="column" align="center" gap={3}>
                           <Loader />
                        </Flex>
                     </Box>
                  )}
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px"
                     style={{ tableLayout: 'fixed', width: '100%', borderCollapse: 'collapse' }}>
                     <TableColGroup />
                     <Tbody>
                        {isLoading ? (
                           <Tr><Td colSpan={8} py="100px"><Loader /></Td></Tr>
                        ) : salesReport?.length === 0 ? (
                           <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
                              <Td colSpan={8} justifyContent="center" alignItems="center" width="100%">
                                 <Grid justifyContent="center" alignItems="center" gap={9}>
                                    <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                                    <GridItem justifySelf="center"><label>No inventory data found</label></GridItem>
                                 </Grid>
                              </Td>
                           </Tr>
                        ) : (
                           memoizedReportContent
                        )}
                     </Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView} onClose={handleSalesDetailsClose}
            singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
            title={entityType === 'saleinvoice' ? 'Sales Invoice' : entityType === 'salereturn' ? 'Sales Return' : entityType === 'purchaseinvoice' ? 'Purchase Invoice' : 'Purchase Return'}
            entityType={entityType} singleEntity={viewDetail}
            handlePrevPage={handlePrevPage} handleNextPage={handleNextPage}
            setIsEditFormOpen={setIsEditFormOpen} setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen} viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems} billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn} handleSerchClose={() => { console.log(''); }}
         />

         <SalesPurchaseFilter isOpen={isFilterOpen} onClose={onFilterClose} companyIds={companyFilter} fromDate={dateRange.fromDate} toDate={dateRange.toDate} entityType={'Inventory Detail'} onApply={() => setIsFilterLoading(true)} />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr} onClose={handleSalesSingleDataViewClose}
            entityType={entityType} singleEntity={singleEntity} dynamicUserDetails={dynamicUserDetails}
            onEditFormClose={() => setIsOpenSingleViewinr(true)} setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen} setIsEditFormOpen={setIsEditFormOpen}
            title={entityType === 'issuemaster' ? 'Issue' : 'Receive'} handleViewSingleData={handleViewSingleData}
         />
      </>
   );
};

export default InventoryDetail;